import { createFileRoute, Outlet } from '@tanstack/react-router'

export const Route = createFileRoute('/(app)/dashboard/invoices')({
  component: InvoicesLayout,
})

function InvoicesLayout() {
  return <Outlet />
}
